import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["contactsContainer", "contactTemplate"]

  connect() {
    if (this.hasContactsContainerTarget) {
      this.nextContactIndex = this.contactsContainerTarget.querySelectorAll("[data-contact-row]").length
    }
  }

  addContactRow(event) {
    event.preventDefault()
    if (!this.hasContactsContainerTarget || !this.hasContactTemplateTarget) return

    const index = this.nextContactIndex
    const html = this.contactTemplateTarget.innerHTML.replace(/NEW_CONTACT/g, index)
    this.contactsContainerTarget.insertAdjacentHTML("beforeend", html)
    this.nextContactIndex += 1
  }

  removeContactRow(event) {
    event.preventDefault()
    const row = event.target.closest("[data-contact-row]")
    if (!row) return

    const destroyField = row.querySelector("[data-destroy-field]")
    if (destroyField) {
      destroyField.value = "1"
      row.querySelectorAll("input:not([type=hidden]), select, textarea").forEach((input) => {
        input.disabled = true
      })
      row.classList.add("hidden")
      return
    }

    row.remove()
  }
}
